import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "head" };
const _hoisted_2 = { key: 3 };
const _hoisted_3 = { key: 4 };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = {
    key: 0,
    class: "mt-2"
};
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useVouchers } from '@/composables/useVouchers';
import HeaderBlock from './elements/HeaderBlock.vue';
import VoucherList from './elements/VoucherList.vue';
import CategoryButton from './elements/CategoryButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'VouchersShopPage',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getAvailableVouchers, getCategories, getCustomerVouchers, removeCustomerFavouriteDiscount, addCustomerFavouriteDiscount, removeUnavailableDiscountProviders } = useVouchers();
        const filter = ref(route.query.filters ?? null);
        const filterCount = ref(0);
        const title = ref(route.query.title ?? "Browse all retail cards");
        const image = ref(route.query.image ?? null);
        const query = ref(null);
        const favourites = ref(false);
        const favouriteVouchers = ref(null);
        async function onLoad() {
            getCategories();
            getCustomer();
            getAvailableVouchers(() => {
                favouriteVouchers.value = state.availableVouchers.filter(v => v.favourite);
                state.availableVouchers.forEach(v => {
                    removeUnavailableDiscountProviders(v);
                });
            });
            getCustomerVouchers();
        }
        function navFilter(o) {
            router.push({ path: '/vouchers', query: o });
        }
        function gotoSearch() {
            router.push({ path: '/vouchers/search' });
        }
        function favouriteToggled(voucher) {
            if (voucher.favourite) {
                removeCustomerFavouriteDiscount(voucher, () => {
                    voucher.favourite = !voucher.favourite;
                });
            }
            else {
                addCustomerFavouriteDiscount(voucher, () => {
                    voucher.favourite = !voucher.favourite;
                });
            }
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_span = _resolveComponent("v-span");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: title.value,
                    border: image.value ? 0 : null,
                    bgcolor: image.value ? '#281C3Bff' : 'white',
                    color: image.value ? 'white' : null
                }, null, 8, ["title", "border", "bgcolor", "color"]),
                (filter.value)
                    ? (_openBlock(), _createBlock(_Transition, { key: 0 }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("div", {
                                    class: "header",
                                    style: _normalizeStyle('background-image: url(' + image.value + ')')
                                }, [
                                    _createVNode(_component_v_row, null, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_col, { class: "v-col-7 title-col" }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("h1", null, _toDisplayString(title.value), 1)
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_col, { class: "v-col-5 count-col" }, {
                                                default: _withCtx(() => [
                                                    (_unref(state).availableVouchers)
                                                        ? (_openBlock(), _createBlock(_component_v_span, { key: 0 }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(filterCount.value) + " voucher" + _toDisplayString(filterCount.value === 1 ? '' : 's'), 1)
                                                            ]),
                                                            _: 1
                                                        }))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ], 4)
                            ])
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                (!filter.value)
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 1,
                        class: "mb-4"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, { class: "search-col" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                        ref: "search",
                                        modelValue: query.value,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((query).value = $event)),
                                        "prepend-inner-icon": "mdi-magnify",
                                        density: "compact",
                                        label: "Search",
                                        variant: "solo",
                                        flat: true,
                                        "hide-details": "",
                                        clearable: "",
                                        "single-line": "",
                                        "bg-color": "#eeeeee",
                                        onClick: gotoSearch
                                    }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                (!filter.value && favouriteVouchers.value && favouriteVouchers.value.length > 0)
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 2,
                        class: "topMenuRow"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, { class: "topMenuCol" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                        class: _normalizeClass(['topTabButton', { selected: !favourites.value }]),
                                        title: "",
                                        onClick: _cache[1] || (_cache[1] = ($event) => (favourites.value = false))
                                    }, {
                                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                                            _createTextVNode("Browse")
                                        ])),
                                        _: 1
                                    }, 8, ["class"])
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_col, { class: "topMenuCol" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                        class: _normalizeClass(['topTabButton', { selected: favourites.value }]),
                                        title: "",
                                        onClick: _cache[2] || (_cache[2] = ($event) => (favourites.value = true))
                                    }, {
                                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                                            _createTextVNode("Favourites")
                                        ])),
                                        _: 1
                                    }, 8, ["class"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                (_unref(state).availableVouchers)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(VoucherList, {
                            showDescription: false,
                            showFavourites: true,
                            groupFavourites: true,
                            onFavouriteToggled: _cache[3] || (_cache[3] = (v) => { favouriteToggled(v); }),
                            onOnFilterApplied: _cache[4] || (_cache[4] = (count) => { filterCount.value = count; }),
                            categories: filter.value,
                            showAll: false,
                            vouchers: _unref(state).availableVouchers,
                            search: false
                        }, null, 8, ["categories", "vouchers"])
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                            return _createElementVNode("div", {
                                key: i,
                                class: "mb-2"
                            }, [
                                _createVNode(_component_v_skeleton_loader, { type: "list-item-avatar-two-line" })
                            ]);
                        }), 64))
                    ])),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (!favourites.value && !filter.value && _unref(state).categories && _unref(state).availableVouchers)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createElementVNode("div", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).categories, (c) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            class: _normalizeClass('hubItemWrapper'),
                                            key: c.id
                                        }, [
                                            _createVNode(CategoryButton, {
                                                onClick: ($event) => { navFilter({ title: c.pageTitle, filters: c.providerFilters, image: c.pageImage }); },
                                                image: c.buttonImage,
                                                title: c.buttonTitle
                                            }, null, 8, ["onClick", "image", "title"])
                                        ]));
                                    }), 128))
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (favourites.value && favouriteVouchers.value && !filter.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createVNode(VoucherList, {
                                    showFavourites: true,
                                    onFavouriteToggled: _cache[5] || (_cache[5] = (v) => { favouriteToggled(v); }),
                                    vouchers: _unref(state).availableVouchers.filter(v => v.favourite),
                                    showAll: true,
                                    search: false
                                }, null, 8, ["vouchers"])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _cache[8] || (_cache[8] = _createElementVNode("div", { style: { "clear": "both" } }, null, -1))
            ], 64));
        };
    }
});
